<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <h3 class="mb-0 text-uppercase">CPD Provider Profile Information</h3>
                <hr class="my-4" />
            </div>

            <div class="col-lg-12 text-right">
                <img :src="photo" class="photo-class"/>
                <br><br>
            </div>

            <div class="table-responsive">

                <table class="table table-bordered">
                    <tbody>
                        <td>
                            <h4>RRR</h4>
                        </td>
                        <td>
                            <h4 class="text-capitalize font-weight-light">
                                {{ application.transaction ? application.transaction.payment_ref : 'N/A' }}
                            </h4>
                        </td>
                        <td>
                            <h4>Institution / <br>Organization's Name</h4>
                        </td>
                        <td>
                            <h4 class="text-capitalize font-weight-light">
                                {{ profile.name ? profile.name : 'N/A' }}
                            </h4>
                        </td>
                        <td>
                            <h4>Email Address</h4>
                        </td>
                        <td>
                            <h4 class="font-weight-light">
                                {{ profile.email ? profile.email : 'N/A' }}
                            </h4>
                        </td>
                    </tbody>
                    <tbody>
                        <td>
                            <h4>Phone No</h4>
                        </td>
                        <td>
                            <h4 class="font-weight-light">
                                {{ profile.phone ? profile.phone : 'N/A' }}
                            </h4>
                        </td>
                        <td>
                            <h4>Cpd's Website</h4>
                        </td>
                        <td>
                            <h4 class="font-weight-light">
                                {{ profile.website ? profile.website : 'N/A' }}
                            </h4>
                        </td>
                        <td>
                            <h4>Category of <br>Organization</h4>
                        </td>
                        <td>
                            <h4 class="text-capitalize font-weight-light">
                                {{ profile.category ? profile.category : 'N/A' }}
                            </h4>
                        </td>
                    </tbody>
                    <tbody>
                        <td>
                            <h4>Office Address</h4>
                        </td>
                        <td colspan="5">
                            <h4 class="text-capitalize font-weight-light">
                                {{ profile.location ? profile.location : 'N/A' }}
                            </h4>
                        </td>
                    </tbody>
                    <tbody>
                        <td>
                            <h4>Type of Accreditation <br>Requested</h4>
                        </td>
                        <td colspan="5">
                            <h4 class="text-capitalize font-weight-light" v-html="accreditation"></h4>
                        </td>
                    </tbody>
                    <tbody>
                        <td>
                            <h4>Experience/Evidence <br>of previous Performance</h4>
                        </td>
                        <td colspan="5">
                            <h4 class="text-capitalize font-weight-light">
                                {{ profile.experience ? profile.experience : 'N/A' }}
                            </h4>
                        </td>
                    </tbody>
                </table>
            </div>
            <div class="col-lg-12">
                <hr class="my-4" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ProfileDetails',
        props: [ 'application' ],
        computed: {
            profile() {
                return this.application ? this.application.cpd : {};
            },
            photo() {// get MD passport
                return this.profile && this.profile.photo && this.profile.photo.image 
                            ? this.profile.photo.image : this.blankImageUrl;
            },
            accreditation() {
                let records = this.application ? this.application.accreditation_type : false;
                if(records) {
                    let items = JSON.parse(records);
                    let text = '';
                    for (let index = 0; index < items.length; index++) {
                        const element = items[index];
                        text += element ? (index+1) + '. ' +element + '<br>' : '';
                    }
                    return text;
                } else {
                    return 'N/A';
                }
            },
        }
    }
</script>

<style scoped>
    .no-padding-bottom {
        padding-bottom: 0rem !important
    }
    .right {
        float: right !important;
    }
    .photo-class {
        width: 200px;
        height: 200px;
    }
</style>

<style>
    .form-control-label {
        width: 100%;
    }
    .height-50 {
        height: 50px;
    }
    .borderLine {
        border: 1px solid #ededed;
    }
</style>